import "./CalculatriceAgircArrco.css";
import { GetCalculCalculatriceAgircArrco, GetSimulateurData, ImportDataCalculCalculatriceAgircArrco } from "components/app/Api/ApiSimulateur";
import { AppContext } from "components/app/RemExprertProvider";
import Button from "components/ui/controls/button/button";
import { createStyledButton } from "components/ui/controls/button/button-styles";
import CardBox from "components/ui/controls/card-box/card-box";
import DropDown from "components/ui/controls/drop-down/drop-down";
import TextField from "components/ui/controls/text-field/text-field";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import { useContext, useEffect, useRef, useState } from "react";
import { FaArrowAltCircleDown, FaCogs, FaPrint, FaCalculator, FaArrowLeft, FaSave, FaUpload, FaExclamationTriangle } from "react-icons/fa";
import _ from "lodash";
import { applyFormat } from "components/ui/ui-helpers";
import Modal from "components/ui/modal/modal";
import { SyntheseCaculatriceAgircArrco } from "components/app/Api/Rapport/ApiRapport";
import ActionButton from "components/ui/controls/action-button/ActionButton";
import { useStudyManagementHandlers } from "pages/studyManagementHandler";
import { PdfReader } from "components/app/Api/Retraite/ApiRetraite";
import { ApplySignedFormat } from "components/app/ApplySignedFormat";

const CalculatriceAgircArrco = (props) => {
  const context = useContext(AppContext);
  const [modalOpen, setmodalOpen] = useState(false);
  const [risError, setRisError] = useState(null);
  const [tabTotal, setTabTotal] = useState({ ptsArrco: 0, ptsAgircTB: 0, ptsAgircTC: 0, ptsAgircArrco: 0, ptsImportes: 0 });
  const { handleSave, handleGoToAudits } = useStudyManagementHandlers(props);
  const fileInputRef = useRef(null);
  const handleFileUpload = () => {
    fileInputRef.current?.click();
  };
  useEffect(() => {
    if (Object.keys(context.state.CalculatriceTableauAgircArrco).length === 0) {
      GetSimulateurData(context.state, "GetTableauCalculatriceAgircArrco").then((res) => {
        context.handleValueChange("CalculatriceTableauAgircArrco", res.detail);
      });
    } else {
      handleCalcul(context.state.CalculatriceTableauAgircArrco);
    }
  }, []);

  const handleChangeValue = (Annee, Property, Value) => {
    let List = _.cloneDeep(context.state.CalculatriceTableauAgircArrco);
    List[Annee][Property] = Value;
    context.handleValueChangeAsync("CalculatriceTableauAgircArrco", List).then(() => {
      handleCalcul(List);
    });
  };
  const handleExpandValue = (AnneeMin, Property) => {
    let List = _.cloneDeep(context.state.CalculatriceTableauAgircArrco);

    Object.keys(context.state.CalculatriceTableauAgircArrco)?.forEach((Annee) => {
      if (Number(Annee) > AnneeMin) {
        if (Property === "Salaire") {
          let Salaire = List[AnneeMin][Property];
          if (Number(AnneeMin) < 2002 && Number(Annee) >= 2002) {
            Salaire = Number(List[AnneeMin][Property] / 6.55957).toFixed(0);
          }
          List[Annee][Property] = Salaire;
        } else {
          List[Annee][Property] = List[AnneeMin][Property];
        }
      }
    });
    context.handleValueChangeAsync("CalculatriceTableauAgircArrco", List).then(() => {
      handleCalcul(List);
    });
  };
  const handleCalcul = (CalculatriceTableauAgircArrco) => {
    GetCalculCalculatriceAgircArrco(CalculatriceTableauAgircArrco, "CalculTableauCalculatriceAgircArrco").then((res) => {
      if (typeof res === "object") {
        setTabTotal(res.total);
        context.handleValueChange("CalculatriceTableauAgircArrco", res.detail);
      }
    });
  };

  const handleUploadRIS = (Infos) => (event) => {
    return PdfReader(event.target.files[0], Infos.IdUser, { Partner: Infos.Partner, IdPartner: Infos.IdPartner }).then((Res) => {
      if ("error" in Res || Res.data === "SizeError") {
        setRisError("Le logiciel n'a pas été en mesure de lire le relevé de carrière : le fichier est un scan.");
        return [];
      } else if (Res.data[0] === "TechnicalError") {
        setRisError("Le logiciel n'a pas été en mesure de lire le relevé de carrière pour des raisons techniques. Votre RIS a été transmis à nos équipes.");
        return [];
      } else if (Res.data[0] === "FileError") {
        setRisError("Le logiciel n'a pas été en mesure de lire le relevé de carrière : fichier converti par l'application " + Res.data[1]["Software"] + ".");
        return [];
      } else {
        return ImportDataCalculCalculatriceAgircArrco(Res.data[1].RISInfos, "ImportTableauCalculatriceAgircArrco").then((result) => {
          return result;
        });
        // ControlRIS(Res.data[1], Infos.IdUser, false, "").then((InfosRIS) => {
        //   setResults(Res.data[1]);
        //   setErrorMessage("");
        //   setSuccessMessage(true);
        //   handleGestionRIS(InfosRIS.data);
        // });
      }
    });
  };
  const handleFileChange = (evt) => {
    if (evt.target.files[0]) {
      handleUploadRIS(context.state)(evt)
        .then((result) => {
          if (!result || !result.detail) return;
          context.handleValueChange("CalculatriceTableauAgircArrco", result.detail);
          setTabTotal(result.total);
          // context.handleAddCorrectionCarriere({ data });
        })
        .catch((error) => {
          console.error("Error uploading RIS:", error);
          // context.handleAddCorrectionCarriere({})
        })
        .finally(() => {
          evt.target.value = null;
        });
    }
  };
  return (
    <>
      <Column fill>
        <Row>
          <Column fill>
            <CardBox>
              <Column fill>
                {(context.state.StatutMarital === "marie" || context.state.StatutMarital === "pacse") && (
                  <Row bpad>
                    <DropDown
                      value={context.state.SwitchClient}
                      onChange={context.handleSwitchClient}
                      label="Etude réalisée pour"
                      options={[
                        { value: "client", label: context.state.SwitchPrenom },
                        { value: "conjoint", label: context.state.SwitchPrenomConjoint },
                      ]}
                      xlarge
                    />
                  </Row>
                )}
                <Row>
                  <Column fill>
                    <div className="dossier-header">
                      <div className="dossier-header-icon">
                        <FaCalculator />
                      </div>
                      <h1 className="dossier-header-title">Calculatrice AGIRC ARRCO</h1>
                      <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap", marginLeft: "auto" }}>
                        <input ref={fileInputRef} type="file" style={{ display: "none" }} onChange={handleFileChange} accept=".pdf" />
                        <ActionButton
                          onClick={handleFileUpload}
                          icon={FaUpload}
                          title="Importer le RIS"
                          subtitle="Relevé tous régimes PDF"
                          colors={{
                            primary: "#f59e0b",
                            secondary: "#d97706",
                            shadow: "rgba(245, 158, 11, 0.4)",
                            shadowHover: "rgba(245, 158, 11, 0.6)",
                            background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                          }}
                          decorativeIcon={{ type: "upload" }}
                          style={{ width: "215px" }}
                        />
                        <ActionButton
                          onClick={() => {
                            setmodalOpen(true);
                          }}
                          icon={FaCogs}
                          title="Paramétrage"
                          subtitle="Modifier les taux"
                          colors={{
                            primary: "#3b82f6",
                            secondary: "#1d4ed8",
                            shadow: "rgba(59, 130, 246, 0.4)",
                            shadowHover: "rgba(59, 130, 246, 0.6)",
                          }}
                          decorativeIcon={{ type: "upload" }}
                          style={{ width: "215px" }}
                        />
                        <ActionButton
                          onClick={() => {
                            SyntheseCaculatriceAgircArrco(context.state, tabTotal);
                          }}
                          icon={FaPrint}
                          title="Impression"
                          subtitle="Editer un Word"
                          colors={{
                            primary: "#11998e",
                            secondary: "#0d7377",
                            shadow: "rgba(17, 153, 142, 0.4)",
                            shadowHover: "rgba(17, 153, 142, 0.6)",
                          }}
                          decorativeIcon={{ type: "document" }}
                          style={{ width: "215px" }}
                        />
                        {context.state.Partner === "" && (
                          <>
                            <ActionButton
                              onClick={() => {
                                handleSave();
                              }}
                              icon={FaSave}
                              title="Sauvegarder"
                              subtitle="Sauvegarder l'étude"
                              colors={{
                                primary: "rgb(124, 58, 237)",
                                secondary: "rgb(109, 40, 217)",
                                shadow: "rgba(124, 58, 237, 0.4)",
                                shadowHover: "rgba(124, 58, 237, 0.6)",
                                background: "linear-gradient(135deg, rgb(124, 58, 237) 0%, rgb(109, 40, 217) 100%)",
                              }}
                              decorativeIcon={{ type: "save" }}
                              style={{ width: "215px" }}
                            />

                            <ActionButton
                              onClick={() => {
                                handleGoToAudits();
                              }}
                              icon={FaArrowLeft}
                              title="Quitter"
                              subtitle="Revenir aux audits"
                              colors={{
                                primary: "#e57373",
                                secondary: "#c62828",
                                shadow: "rgba(229, 115, 115, 0.4)",
                                shadowHover: "rgba(229, 115, 115, 0.6)",
                              }}
                              decorativeIcon={{ type: "previous" }}
                              style={{ width: "215px" }}
                            />
                          </>
                        )}
                      </div>
                    </div>
                    <Row center></Row>
                    <Row tpad>
                      <div className="revenuspro-container" style={{ paddingLeft: "0px" }}>
                        {/* Header séparé */}
                        <div className="header-card">
                          <div
                            className="category-column"
                            style={{ textAlign: "center", maxWidth: "120px", minWidth: "120px", display: "flex", alignItems: "center", justifyContent: "center" }}
                          >
                            Année
                          </div>
                          <div className="value-column" style={{ textAlign: "center", minWidth: "140px" }}>
                            Statut
                          </div>
                          <div className="action-column" style={{ width: "40px" }}></div>
                          <div className="value-column" style={{ textAlign: "center" }}>
                            Salaire brut
                          </div>
                          <div className="action-column" style={{ width: "40px" }}></div>
                          <div className="value-column" style={{ textAlign: "center" }}>
                            Taux d'activité
                          </div>
                          <div className="action-column" style={{ width: "40px" }}></div>
                          <div className="value-column" style={{ textAlign: "center" }}>
                            ARRCO
                          </div>
                          <div className="value-column" style={{ textAlign: "center" }}>
                            AGIRC TB
                          </div>
                          <div className="value-column" style={{ textAlign: "center" }}>
                            AGIRC TC
                          </div>
                          <div className="value-column" style={{ textAlign: "center" }}>
                            AGIRC-ARRCO calculé
                          </div>
                          <div className="value-column" style={{ textAlign: "center" }}>
                            AGIRC-ARRCO importé
                          </div>
                          <div className="value-column" style={{ textAlign: "center" }}>
                            Diff.
                          </div>
                        </div>

                        {/* Conteneur des cartes de contenu */}
                        <div className="card-list-container">
                          {Object.keys(context.state.CalculatriceTableauAgircArrco || {})?.map((Annee, index) => {
                            return (
                              <div key={"Calc" + Annee} className="card" style={{ display: "flex", alignItems: "center", minHeight: "60px" }}>
                                <div
                                  className="category-column"
                                  style={{ maxWidth: "120px", minWidth: "120px", textAlign: "center", display: "flex", alignItems: "center", justifyContent: "center" }}
                                >
                                  <span className="trimester-year-badge" style={{ flex: 0, minWidth: "70px" }}>
                                    {Annee}
                                  </span>
                                </div>
                                <div className="value-column" style={{ textAlign: "center", minWidth: "140px" }}>
                                  <DropDown
                                    style={{ textAlign: "center" }}
                                    value={context.state.CalculatriceTableauAgircArrco[Annee]["Statut"]}
                                    onChange={(e) => {
                                      handleChangeValue(Annee, "Statut", e.target.value);
                                    }}
                                    options={[
                                      { value: "cadre", label: "Cadre" },
                                      { value: "nonCadre", label: "Non cadre" },
                                    ]}
                                    large
                                  />
                                </div>
                                <div className="action-column" style={{ width: "40px" }}>
                                  <Button
                                    tabIndex="-1"
                                    icon
                                    onClick={() => handleExpandValue(Annee, "Statut")}
                                    {...createStyledButton("card-action", "cardEdit", { backgroundColor: "#dbeafe" })}
                                  >
                                    <FaArrowAltCircleDown style={{ color: "#3b82f6", fontSize: "12px" }} />
                                  </Button>
                                </div>
                                <div className="value-column" style={{ textAlign: "center" }}>
                                  <TextField
                                    value={context.state.CalculatriceTableauAgircArrco[Annee]["Salaire"]}
                                    dataType="uint"
                                    format={{ thousands: " ", unit: Number(Annee) < 2002 ? " FRF" : " €" }}
                                    onChange={(e) => {
                                      handleChangeValue(Annee, "Salaire", e.target.value);
                                    }}
                                  />
                                </div>
                                <div className="action-column" style={{ width: "40px" }}>
                                  <Button
                                    tabIndex="-1"
                                    icon
                                    onClick={() => handleExpandValue(Annee, "Salaire")}
                                    {...createStyledButton("card-action", "cardEdit", { backgroundColor: "#dbeafe" })}
                                  >
                                    <FaArrowAltCircleDown style={{ color: "#3b82f6", fontSize: "12px" }} />
                                  </Button>
                                </div>
                                <div className="value-column" style={{ textAlign: "center" }}>
                                  <TextField
                                    value={context.state.CalculatriceTableauAgircArrco[Annee]["TauxActivite"]}
                                    dataType="ufloat"
                                    format={{ thousands: " ", precision: 2, decimal: ",", unit: "%" }}
                                    onChange={(e) => {
                                      handleChangeValue(Annee, "TauxActivite", e.target.value);
                                    }}
                                  />
                                </div>
                                <div className="action-column" style={{ width: "40px" }}>
                                  <Button
                                    tabIndex="-1"
                                    icon
                                    onClick={() => handleExpandValue(Annee, "TauxActivite")}
                                    {...createStyledButton("card-action", "cardEdit", { backgroundColor: "#dbeafe" })}
                                  >
                                    <FaArrowAltCircleDown style={{ color: "#3b82f6", fontSize: "12px" }} />
                                  </Button>
                                </div>
                                <div className="value-column" style={{ textAlign: "center" }}>
                                  {applyFormat(context.state.CalculatriceTableauAgircArrco[Annee]["PtsArrco"], "ufloat", { thousands: " ", decimal: ",", precision: 2 })}
                                </div>
                                <div className="value-column" style={{ textAlign: "center" }}>
                                  {applyFormat(context.state.CalculatriceTableauAgircArrco[Annee]["PtsAgircTB"], "ufloat", { thousands: " ", decimal: ",", precision: 2 })}
                                </div>
                                <div className="value-column" style={{ textAlign: "center" }}>
                                  {applyFormat(context.state.CalculatriceTableauAgircArrco[Annee]["PtsAgircTC"], "ufloat", { thousands: " ", decimal: ",", precision: 2 })}
                                </div>
                                <div className="value-column" style={{ textAlign: "center" }}>
                                  {applyFormat(context.state.CalculatriceTableauAgircArrco[Annee]["PtsAgircArrco"], "ufloat", { thousands: " ", decimal: ",", precision: 2 })}
                                </div>
                                <div className="value-column" style={{ textAlign: "center" }}>
                                  {applyFormat(context.state.CalculatriceTableauAgircArrco[Annee]["PointsAgircArrcoImporte"], "float", { thousands: " ", decimal: ",", precision: 2 })}
                                </div>
                                <div className="value-column" style={{ textAlign: "center" }}>
                                  {context.state.CalculatriceTableauAgircArrco[Annee]["PointsAgircArrcoImporte"]
                                    ? ApplySignedFormat(
                                        context.state.CalculatriceTableauAgircArrco[Annee]["PtsAgircArrco"] - context.state.CalculatriceTableauAgircArrco[Annee]["PointsAgircArrcoImporte"],
                                        "",
                                        2
                                      )
                                    : ""}
                                </div>
                              </div>
                            );
                          })}

                          {/* Carte récapitulative Total */}
                          <div className="card" style={{ backgroundColor: "#f3f4f6", fontWeight: "600" }}>
                            <div className="category-column" style={{ fontWeight: "600", textAlign: "center", maxWidth: "120px" }}>
                              <span>Total</span>
                            </div>
                            <div className="value-column" style={{ fontWeight: "600", textAlign: "center", minWidth: "140px" }}></div>
                            <div className="action-column" style={{ width: "40px" }}></div>
                            <div className="value-column" style={{ fontWeight: "600", textAlign: "center" }}></div>
                            <div className="action-column" style={{ width: "40px" }}></div>
                            <div className="value-column" style={{ fontWeight: "600", textAlign: "center" }}></div>
                            <div className="action-column" style={{ width: "40px" }}></div>
                            <div className="value-column" style={{ fontWeight: "600", textAlign: "center" }}>
                              {applyFormat(tabTotal.ptsArrco, "ufloat", { thousands: " ", decimal: ",", precision: 2 })}
                            </div>
                            <div className="value-column" style={{ fontWeight: "600", textAlign: "center" }}>
                              {applyFormat(tabTotal.ptsAgircTB, "ufloat", { thousands: " ", decimal: ",", precision: 2 })}
                            </div>
                            <div className="value-column" style={{ fontWeight: "600", textAlign: "center" }}>
                              {applyFormat(tabTotal.ptsAgircTC, "ufloat", { thousands: " ", decimal: ",", precision: 2 })}
                            </div>
                            <div className="value-column" style={{ fontWeight: "600", textAlign: "center" }}>
                              {applyFormat(tabTotal.ptsAgircArrco, "ufloat", { thousands: " ", decimal: ",", precision: 2 })}
                            </div>
                            <div className="value-column" style={{ fontWeight: "600", textAlign: "center" }}>
                              {applyFormat(tabTotal.ptsImportes, "ufloat", { thousands: " ", decimal: ",", precision: 2 })}
                            </div>
                            <div className="value-column" style={{ fontWeight: "600", textAlign: "center" }}>
                              {tabTotal.ptsImportes ? ApplySignedFormat(tabTotal.ptsAgircArrco - tabTotal.ptsImportes, "", 2) : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Row>
                  </Column>
                </Row>
              </Column>
            </CardBox>
          </Column>
        </Row>
      </Column>
      {risError !== null && (
        <div
          onClick={() => setRisError(null)}
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 9999,
            background: "rgba(0,0,0,0.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#fff",
              borderRadius: "16px",
              boxShadow: "0 24px 60px rgba(0,0,0,0.25)",
              width: "420px",
              overflow: "hidden",
              fontFamily: "inherit",
            }}
          >
            {/* Header rouge */}
            <div
              style={{
                background: "linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)",
                padding: "20px 24px",
                display: "flex",
                alignItems: "center",
                gap: "12px",
              }}
            >
              <div
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  background: "rgba(255,255,255,0.2)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <FaExclamationTriangle style={{ color: "#fff", fontSize: "18px" }} />
              </div>
              <div>
                <div style={{ color: "#fff", fontWeight: "700", fontSize: "16px" }}>Erreur d'import</div>
                <div style={{ color: "rgba(255,255,255,0.75)", fontSize: "12px" }}>Relevé individuel de situation</div>
              </div>
              <button
                onClick={() => setRisError(null)}
                style={{
                  marginLeft: "auto",
                  background: "rgba(255,255,255,0.15)",
                  border: "none",
                  color: "#fff",
                  width: "28px",
                  height: "28px",
                  borderRadius: "50%",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "14px",
                  flexShrink: 0,
                }}
              >
                ✕
              </button>
            </div>

            {/* Contenu */}
            <div style={{ padding: "24px" }}>
              <p style={{ margin: "0 0 20px 0", color: "#444", lineHeight: "1.6", fontSize: "14px" }}>{risError}</p>
              <button
                onClick={() => setRisError(null)}
                style={{
                  width: "100%",
                  padding: "10px",
                  background: "linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)",
                  color: "#fff",
                  border: "none",
                  borderRadius: "8px",
                  fontWeight: "600",
                  fontSize: "14px",
                  cursor: "pointer",
                  letterSpacing: "0.3px",
                }}
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      )}
      <Modal
        width="80%"
        height="80%"
        title="Paramétrage"
        icon={<FaCogs />}
        visible={modalOpen}
        onClose={() => {
          setmodalOpen(false);
        }}
      >
        <div className="revenuspro-container scroll">
          {/* Header séparé */}
          <div className="header-card">
            <div className="category-column" style={{ textAlign: "center", minWidth: "140px", maxWidth: "140px", justifyContent: "center" }}>
              Année
            </div>
            <div className="value-column" style={{ textAlign: "center" }}>
              Taux ARRCO T1
            </div>
            <div className="value-column" style={{ textAlign: "center" }}>
              Taux ARRCO T2
            </div>
            <div className="value-column" style={{ textAlign: "center" }}>
              Taux AGIRC TB
            </div>
            <div className="value-column" style={{ textAlign: "center" }}>
              Taux AGIRC TC
            </div>
            <div className="value-column" style={{ textAlign: "center" }}>
              Sal. ref ARRCO
            </div>
            <div className="value-column" style={{ textAlign: "center" }}>
              Sal.ref AGIRC
            </div>
          </div>

          {/* Conteneur des cartes de contenu */}
          <div className="card-list-container">
            {Object.keys(context.state.CalculatriceTableauAgircArrco)?.map((Annee, index) => {
              return (
                <div key={"Calc" + Annee} className="card">
                  <div className="category-column" style={{ minWidth: "140px", maxWidth: "140px", textAlign: "center", paddingLeft: "12px" }}>
                    <span className="trimester-year-badge" style={{ minWidth: "70px" }}>
                      {Annee}
                    </span>
                  </div>
                  <div className="value-column" style={{ textAlign: "center" }}>
                    <TextField
                      value={context.state.CalculatriceTableauAgircArrco[Annee]["TauxArrcoT1"] * 100}
                      dataType="ufloat"
                      format={{ thousands: " ", precision: 2, decimal: ",", unit: "%" }}
                      onChange={(e) => {
                        handleChangeValue(Annee, "TauxArrcoT1", Number(Number(e.target.value) / 100).toFixed(4));
                      }}
                    />
                  </div>
                  <div className="value-column" style={{ textAlign: "center" }}>
                    <TextField
                      value={context.state.CalculatriceTableauAgircArrco[Annee]["TauxArrcoT2"] * 100}
                      dataType="ufloat"
                      format={{ thousands: " ", precision: 2, decimal: ",", unit: "%" }}
                      onChange={(e) => {
                        handleChangeValue(Annee, "TauxArrcoT2", Number(Number(e.target.value) / 100).toFixed(4));
                      }}
                    />
                  </div>
                  <div className="value-column" style={{ textAlign: "center" }}>
                    {Number(Annee) <= 2018 && (
                      <TextField
                        value={context.state.CalculatriceTableauAgircArrco[Annee]["TauxAgircTB"] * 100}
                        dataType="ufloat"
                        format={{ thousands: " ", precision: 2, decimal: ",", unit: "%" }}
                        onChange={(e) => {
                          handleChangeValue(Annee, "TauxAgircTB", Number(Number(e.target.value) / 100).toFixed(4));
                        }}
                      />
                    )}
                  </div>
                  <div className="value-column" style={{ textAlign: "center" }}>
                    {Number(Annee) >= 1988 && Number(Annee) <= 2018 && (
                      <TextField
                        value={context.state.CalculatriceTableauAgircArrco[Annee]["TauxAgircTC"] * 100}
                        dataType="ufloat"
                        format={{ thousands: " ", precision: 2, decimal: ",", unit: "%" }}
                        onChange={(e) => {
                          handleChangeValue(Annee, "TauxAgircTC", Number(Number(e.target.value) / 100).toFixed(4));
                        }}
                      />
                    )}
                  </div>
                  <div className="value-column" style={{ textAlign: "center" }}>
                    <TextField
                      value={context.state.CalculatriceTableauAgircArrco[Annee]["SalRefArrco"]}
                      dataType="ufloat"
                      format={{ thousands: " ", precision: 4, decimal: ",", unit: Number(Annee) < 2002 ? " FRF" : " €" }}
                      onChange={(e) => {
                        handleChangeValue(Annee, "SalRefArrco", e.target.value);
                      }}
                    />
                  </div>
                  <div className="value-column" style={{ textAlign: "center" }}>
                    {Number(Annee) <= 2018 && (
                      <TextField
                        value={context.state.CalculatriceTableauAgircArrco[Annee]["SalRefAgirc"]}
                        dataType="ufloat"
                        format={{ thousands: " ", precision: 4, decimal: ",", unit: Number(Annee) < 2002 ? " FRF" : " €" }}
                        onChange={(e) => {
                          handleChangeValue(Annee, "SalRefAgirc", e.target.value);
                        }}
                      />
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default CalculatriceAgircArrco;
